import GTMEvent from "@/types/GTMEvent";

/* Note events */
const category = "reactions";

export const reactionSubmitted = {
  category,
  name: "newReaction",
  action: "submitted",
  label: "User submitted a reaction",
} as GTMEvent;
